export const DDC_VIDEO_SEEK = 'ddc.video.seek';
export const VIDEO_SEEK = 'video-seek';

// Fires once per user (or programmatic) seek, on the native 'seeked' event —
// i.e. after the browser has finished moving to the new position. This is
// what a scrub on the timeline reports; it replaces the pause+play pair the
// browser fires internally while scrubbing (see pause.js / resume.js), so
// seeking a playing video is one event instead of two unrelated ones.
function seek(event) {
	const {
		currentTarget: element,
		currentTarget: {
			duration: videoDuration = '',
			currentSrc: videoSource,
			currentTime = 0
		} = {}
	} = event;

	return {
		eventType: DDC_VIDEO_SEEK,
		eventData: {
			element,
			videoSource,
			videoDuration,
			currentTime,
			fileType:
				typeof videoSource === 'string'
					? videoSource.split('.').pop()
					: ''
		},
		overrides: {
			eventType: VIDEO_SEEK
		}
	};
}

export default seek;
